import { render, staticRenderFns } from "./SLigoAssistantAvatar.vue?vue&type=template&id=6f2c9cc7&"
import script from "./SLigoAssistantAvatar.vue?vue&type=script&lang=ts&"
export * from "./SLigoAssistantAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./SLigoAssistantAvatar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports